<app-wrapper>

  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Рассылка
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="send()" [disabled]="form.invalid" class="btn btn-primary">
            <i class="fa-solid fa-paper-plane"></i>&nbsp;Отправить
          </button>
        </div>
      </div>
    </div>
    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <div class="row">
            <div class="col-12">
              <div class="form-check form-switch mb-3">
                <input class="form-check-input" type="checkbox" name="sendAll"
                  [(ngModel)]="model.sendAll">
                  <label class="form-check-label" for="flexSwitchCheckDefault">Отправить всем</label>
                </div>
              </div>
              @if (!model.sendAll) {
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg-3 col-md-6">
                      <div class="form-check form-check mb-3">
                        <input class="form-check-input" [(ngModel)]="byAverageSum" type="checkbox"
                          name="byAverageSum">
                          <label class="form-check-label">Средний чек</label>
                        </div>
                        <div class="row">
                          <div class="col-8">
                            <div class="form-floating mb-3">
                              <input type="text" name="averageSum" [(ngModel)]="model.averageSum"
                                [disabled]="!byAverageSum" class="form-control" required
                                placeholder="Заголовок">
                                <label>Сумма</label>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="form-check form-check mb-3">
                                <input class="form-check-input" [(ngModel)]="model.lessAverageSum"
                                  [disabled]="!byAverageSum" type="checkbox" name="lessAverageSum">
                                  <label class="form-check-label">Меньше</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-6">
                            <div class="form-check form-check mb-3">
                              <input class="form-check-input" [(ngModel)]="byDate" type="checkbox"
                                name="byDate">
                                <label class="form-check-label">Дата совершения покупок</label>
                              </div>
                              <div class="row">
                                <div class="col-6">
                                  <div class="form-floating mb-3">
                                    <input class="form-control" readonly name="startDate" [disabled]="!byDate"
                                      [(ngModel)]="startDate" ngbDatepicker #dStart="ngbDatepicker" required
                                      (click)="dStart.toggle()" />
                                      <label>С</label>
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <div class="form-floating mb-3">
                                      <input class="form-control" readonly name="endDate" [disabled]="!byDate" required
                                        [(ngModel)]="endDate" ngbDatepicker #dEnd="ngbDatepicker"
                                        (click)="dEnd.toggle()" />
                                        <label>По</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>
                          }
                          <div class="col-md-4 col-lg-2">
                            <div class="form-group">
                              <div class="form-floating mb-3">
                                <input type="text" name="caption" [(ngModel)]="model.caption" maxlength="150"
                                  class="form-control" required placeholder="Заголовок">
                                  <label>Заголовок</label>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 mb-4">
                              <div class="form-group">
                                <div class="form-floating mb-3">
                                  <textarea [(ngModel)]="model.text" maxlength="1000" name="text"
                                  placeholder="Основной текст" rows="5" class="form-control" required></textarea>
                                  <label>
                                    Основной Текст
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    @if (isBusy) {
                      <div class="overlay">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                      </div>
                    }

                  </div>
                </app-wrapper>